/** Local calendar date as YYYY-MM-DD (for date inputs). */
export function getTodayDateString() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function isFutureReceiveDate(dateString) {
  if (!dateString) return false;
  return dateString > getTodayDateString();
}

export function getReceiveDateValidationError(
  dateString,
  { required = true } = {},
) {
  if (!dateString) {
    return required ? "Please select receive date" : "";
  }
  if (isFutureReceiveDate(dateString)) {
    return "Receive date cannot be a future date";
  }
  return "";
}

/** Props for receive-date fields: past + today allowed, future blocked. */
export function getReceiveDateInputProps(value, onChange) {
  return {
    type: "date",
    value,
    max: getTodayDateString(),
    onChange,
    required: true,
  };
}

/**
 * Validate receive date before submit.
 * Resets to today when a future date was entered.
 * @returns {string} error message, or "" when valid
 */
export function validateReceiveDate(dateString, setReceiveDate) {
  const error = getReceiveDateValidationError(dateString);
  if (!error) return "";

  if (isFutureReceiveDate(dateString)) {
    setReceiveDate(getTodayDateString());
  }
  return error;
}
